(function ($) {
  DJ.addBehavior('genericBlock', '.generic-block--scrollable', {
    attach: function () {
      const genericBlock = this;
      const blockToScroll = genericBlock.querySelector('.generic-block__body');

      /**
       * Adding custom scroll to the block.
       */
      if (blockToScroll) {
        jcf.replace(blockToScroll, 'Scrollable');
      }
    }
  });
})(jQuery);
